export const transformShippingOpenHoursDto = _ref => {
  let {
    opens_at,
    closes_at
  } = _ref;
  return {
    opensAt: opens_at,
    closesAt: closes_at
  };
};
export const transformShippingBusinessHoursDto = _ref2 => {
  let {
    weekday,
    label,
    hours
  } = _ref2;
  return {
    weekday,
    label,
    hours: hours === null || hours === void 0 ? void 0 : hours.map(transformShippingOpenHoursDto)
  };
};
export const transformShippingPointDto = _ref3 => {
  let {
    uuid,
    code,
    carrier_code,
    latitude,
    longitude,
    name,
    city,
    description,
    address_line1,
    address_line2,
    postal_code,
    photo_url,
    business_hours,
    labels
  } = _ref3;
  return {
    uuid,
    code,
    carrierCode: carrier_code,
    latitude,
    longitude,
    name,
    city,
    description,
    addressLine1: address_line1,
    addressLine2: address_line2,
    postalCode: postal_code,
    photoUrl: photo_url,
    businessHours: business_hours === null || business_hours === void 0 ? void 0 : business_hours.map(transformShippingBusinessHoursDto),
    labels
  };
};